import { matchesSelector } from '@/plugins/dnd-zone/utils';

export function isClickOnBox(target) {
  return matchesSelector(target, '.grid-item__wrapper, .grid-item__wrapper *');
}
export function isClickOnContent(target) {
  return matchesSelector(target, '.grid-item__content, .grid-item__content *');
}

export function isClickOnBorder(target) {
  return matchesSelector(target, '.grid-item__wrapper');
}
